import { Controller } from "@hotwired/stimulus"

// data-controller="copy"
// data-copy-text-value="https://..."
// data-action="click->copy#copy"
// Optional confirmation target:
//   <span data-copy-target="label" data-copy-default="Copy" data-copy-success="Copied!">
export default class extends Controller {
  static values = {
    text: String,
    successMessage: { type: String, default: "Copied!" },
    revertAfterMs: { type: Number, default: 1600 },
  }
  static targets = ["label", "icon"]
  static classes = ["success"]

  async copy(event) {
    event?.preventDefault?.()
    const text = this.textValue
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      const ta = document.createElement("textarea")
      ta.value = text
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand("copy") } catch {}
      ta.remove()
    }

    if (this.hasLabelTarget) {
      this._original = this._original ?? this.labelTarget.innerHTML
      this.labelTarget.textContent = this.successMessageValue
    }
    if (this.successClasses?.length) {
      this.successClasses.forEach((c) => this.element.classList.add(c))
    }

    clearTimeout(this._timer)
    this._timer = setTimeout(() => this._revert(), this.revertAfterMsValue)
  }

  _revert() {
    if (this.hasLabelTarget && this._original != null) {
      this.labelTarget.innerHTML = this._original
    }
    if (this.successClasses?.length) {
      this.successClasses.forEach((c) => this.element.classList.remove(c))
    }
  }

  disconnect() {
    clearTimeout(this._timer)
  }
}
